import { PetAvatar } from "@/components/PetAvatar";
import { DoodleStar } from "@/components/Doodles";

const getPetName = () => localStorage.getItem('you_pet_name') || 'Your pet';

const ERROR_CONFIG = {
  generation_failed: { state: "thinking", get title() { return `${getPetName()} tripped!`; },     message: "Something went wrong generating your story.",  button: "Try again 🔄" },
  no_internet:       { state: "sad",      title: "No internet!",       message: "Check your connection and try again.",          button: "Check connection" },
  topic_blocked:     { state: "thinking", title: "Not that one!",      message: "Try a school topic like Water Cycle or Maths.", button: "Go back" },
  rate_limited:      { state: "thinking", get title() { return "Slow down!"; },         get message() { return `${getPetName()} needs a breather. Wait a moment.`; },         button: "Wait a minute" },
  generic:           { state: "sad",      title: "Priya & Bunty are taking a short break! 😴", message: "Try again in a moment — they'll be back!", button: "Try again 🔄" },
};

export const ErrorState = ({ type = "generic", onRetry, onDismiss, petType }) => {
  const { state, title, message, button } = ERROR_CONFIG[type] ?? ERROR_CONFIG.generic;
  const handleDismiss = onDismiss || onRetry;
  return (
    <div
      role="alert"
      aria-live="polite"
      onClick={handleDismiss}
      style={{
        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
        zIndex: 1000, background: "rgba(0,0,0,0.3)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#FFFFFF", border: "1.5px dashed #CCCCCC",
          borderRadius: 4, padding: 24, maxWidth: 320, width: "90%",
          textAlign: "center", position: "relative",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 12,
        }}
      >
        {/* Close button */}
        <button
          onClick={handleDismiss}
          aria-label="Close"
          style={{
            position: "absolute", top: 8, right: 8,
            width: 32, height: 32, borderRadius: "50%",
            background: "transparent", border: "1.5px dashed #CCCCCC",
            color: "#888", fontSize: 16, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 0,
          }}
        >
          ✕
        </button>

        <div style={{ position: 'absolute', top: 12, left: 12, pointerEvents: 'none' }}>
          <DoodleStar color="#FF6B6B" opacity={0.15} size={12} />
        </div>

        <PetAvatar size={80} state={state} petType={petType || localStorage.getItem("you_pet_type") || "panda"} />
        <p style={{ fontSize: 18, fontWeight: 400, fontFamily: "'Patrick Hand', cursive", color: "#1A1A2E", margin: 0 }}>{title}</p>
        <p style={{ fontSize: 14, color: "#666666", margin: 0, lineHeight: 1.5 }}>{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            aria-label={button}
            style={{
              marginTop: 4, padding: "14px 24px", borderRadius: 12, fontSize: 16,
              fontWeight: 400, border: "none", cursor: "pointer", width: "100%",
              background: "#448AFF", color: "#fff", fontFamily: "'Patrick Hand', cursive",
              minHeight: 48,
            }}
          >
            {button}
          </button>
        )}
      </div>
    </div>
  );
};
